import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { ModifyCategoryDTO } from "../../dto";

type ModifyCategoryActionProps = {
  id: number;
  title: string;
};

let body: ModifyCategoryDTO;

export async function modifyCategoryAction(props: ModifyCategoryActionProps) {
  const token = localStorage.getItem("token");

  const params = {
    id: props.id,
    title: props.title,
  };

  return await axios
    .patch(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/categories/modify`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(ModifyCategoryDTO, res.data);
      await validate(body);
      const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
